import React from 'react';
import { Button } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';
import { isEmpty } from 'lodash';

import { resolveExtension } from '@plone/volto/helpers/Extensions';
import config from '@plone/volto/registry';

const messages = defineMessages({
  currentFilters: {
    id: 'Current filters applied',
    defaultMessage: 'Current filters applied',
  },
  clearFilters: {
    id: 'Clear filters',
    defaultMessage: 'Clear filters',
  },
});

/**
 * A list of active filtered values and controls to clear those filters.
 *
 */
const FilterList = (props) => {
  const { data = {}, facets = {}, setFacets, isEditMode } = props;
  const definedFacets = data.facets || [];

  const totalFilters = definedFacets.filter(
    ({ field }) =>
      field &&
      Object.keys(facets).includes(field.value) &&
      !isEmpty(facets[field.value]),
  ).length;

  const { types: facetWidgetTypes } =
    config.blocks.blocksConfig.search.extensions.facetWidgets;

  const intl = useIntl();

  return totalFilters ? (
    <div className="filter-listing">
      <div className="number-clear">
        <div className="filter-list-title">
          {/* <VoltoIcon name={downSVG} size="18px" /> */}
          {intl.formatMessage(messages.currentFilters)}: {totalFilters}
        </div>
        <Button
          icon
          basic
          compact
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            !isEditMode && setFacets({});
          }}
        >
          {/* <Icon name="trash" /> */}
          {intl.formatMessage(messages.clearFilters)}
        </Button>
      </div>
      <div className="filter-list-content">
        <div className="filter-list">
          {data.facets?.map((facetSettings, i) => {
            const { filterListComponent: FilterListComponent } =
              resolveExtension('type', facetWidgetTypes, facetSettings);
            const facet = facetSettings?.field?.value;
            if (!facet) return null;

            return (
              <React.Fragment key={i}>
                {Object.keys(facets).includes(facet) && !!facets[facet] && (
                  <div className="filter-list-group">
                    <span className="label-title">
                      {facetSettings.title ?? facetSettings?.field?.label}
                    </span>
                    <FilterListComponent {...props} facet={facet} />
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  ) : null;
};

export default FilterList;
